<template>
  <div class="bg">
    <div class="infoWrapper">
      <div class="infoLine flex">
        <div class="infoTitle">公司名称<span style="color: red">*</span></div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.companyName" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">营业执照<span style="color: red">*</span></div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.companyCode" />
        </div>
      </div>
      <AddressPicker v-model="params.addressCode"></AddressPicker>
      <div class="infoLine flex">
        <div class="infoTitle"></div>
        <div class="infoText flex1">
          <input placeholder="具体地址" v-model="params.address" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle" style="width: 100px;">注册地址</div>
        <div class="infoText flex1">
          <div class="getInfoButton" @click="getRegisteredAddress">
            同步详细地址
          </div>
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.registeredAddress" />
        </div>
      </div>

      <div class="infoLine">
        <div class="infoTitle" style="width: 100%;">
          营业执照上传
          <span class="tip" @click="tipText1 = !tipText1">!</span>
          <div class="tipText" v-show="tipText1">
            需上传营业执照正本并加盖公章
          </div>
        </div>
        <div class="uploadBox">
          <div class="uploadImgBox">
            <uploadImg v-model="params.businessLicenseUrl"></uploadImg>
            <div v-if="params.businessLicenseUrl">
              <img :src="params.businessLicenseUrl" />
            </div>
            <div v-else>
              <img src="../../assets/xiangji.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--		<button style="background: #fff;font-size: 16px" @click="getApproveInfo">获取当前账号信息</button>-->
    <div class="infoLine flex">
      <div class="infoTitle" style="width: 100px;">企业法人信息</div>
      <div class="infoText flex1">
        <div class="getInfoButton" @click="getApproveInfo">获取信息</div>
      </div>
    </div>
    <div class="infoWrapper">
      <div class="infoLine flex">
        <div class="infoTitle">法人姓名<span style="color: red">*</span></div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.legalPerson" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">联系方式</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.legalPersonPhone" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">身份证<span style="color: red">*</span></div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.legalPersonId" />
        </div>
      </div>
      <div class="infoLine">
        <div class="infoTitle" style="width: 100%;">
          法人身份证人像面
          <span class="tip" @click="tipText2 = !tipText2">!</span>
          <div class="tipText" v-show="tipText2">需上传身份证照人像面</div>
        </div>
        <div class="uploadBox">
          <div class="uploadImgBox">
            <uploadImg v-model="params.legalPersonIdcardSurfaceUrl"></uploadImg>
            <div v-if="params.legalPersonIdcardSurfaceUrl">
              <img :src="params.legalPersonIdcardSurfaceUrl" />
            </div>
            <div v-else>
              <img src="../../assets/xiangji.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="infoLine">
        <div class="infoTitle" style="width: 100%;">
          法人身份证国徽面
          <span class="tip" @click="tipText3 = !tipText3">!</span>
          <div class="tipText" v-show="tipText3">需上传身份证国徽面</div>
        </div>
        <div class="uploadBox">
          <div class="uploadImgBox">
            <uploadImg v-model="params.legalPersonIdcardEmblemUrl"></uploadImg>
            <div v-if="params.legalPersonIdcardEmblemUrl">
              <img :src="params.legalPersonIdcardEmblemUrl" />
            </div>
            <div v-else>
              <img src="../../assets/xiangji.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="infoLine">
        <div class="infoTitle" style="width: 100%;">
          上海银行授权书
          <span class="tip" @click="tipText4 = !tipText4">!</span>
          <div class="tipText" v-show="tipText4">需上传上海银行授权书</div>
        </div>
        <div class="uploadBox">
          <div class="uploadImgBox">
            <uploadImg
              v-model="params.shanghaiAuthorizationUserUser"
            ></uploadImg>
            <div v-if="params.shanghaiAuthorizationUserUser">
              <img :src="params.shanghaiAuthorizationUserUser" />
            </div>
            <div v-else>
              <img src="../../assets/xiangji.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="saveButton" @click="submit">保存</div>
  </div>
</template>

<script>
import AddressPicker from "@/components/Address/address";
import uploadImg from "@/components/uploadImg/uploadImg";
import { approveInfo } from "@/api/client.js";
import { companySubmit } from "@/api/company.js";
import { getCompanyDetail } from "../../api/identify";
import { getLocationList } from "../../api/address";
export default {
  components: {
    AddressPicker,
    uploadImg
  },
  data() {
    return {
      tipText1: false,
      tipText2: false,
      tipText3: false,
      tipText4: false,
      wait_timer: false,
      isDisable: false,
      params: {
        companyName: "",
        companyCode: "",
        registeredAddress: "",
        addressCode: "",
        address: "",
        businessLicenseUrl: "",
        legalPerson: "",
        legalPersonPhone: "",
        legalPersonId: "",
        legalPersonIdcardSurfaceUrl: "",
        legalPersonIdcardEmblemUrl: "",
        shanghaiAuthorizationUserUser: "",
        contact: "",
        contactPhone: ""
      },
      submitLoading: false,
      companyId: ""
    };
  },
  created() {
    this.companyId = this.$route.query.companyId;
    this.getCompanyDetail();
  },
  methods: {
    getRegisteredAddress() {
      this.$vux.loading.show();
      let that = this;
      getLocationList()
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            if (res[i].children) {
              for (let x = 0; x < res[i].children.length; x++) {
                for (let y = 0; y < res[i].children[x].children.length; y++) {
                  if (
                    res[i].children[x].children[y].id == that.params.addressCode
                  ) {
                    let label =
                      res[i].title +
                      res[i].children[x].title +
                      res[i].children[x].children[y].title +
                      that.params.address;
                    that.params.registeredAddress = label;
                    this.$vux.loading.hide();
                  } else {
                    this.$vux.loading.hide();
                  }
                }
              }
            } else {
              this.$vux.loading.hide();
            }
          }
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    handleRegion(region) {
      for (let i = 0; i < region.length; i++) {
        if (region[i].children) {
          this.cityData.push({
            name: region[i].title,
            value: region[i].id,
            parent: region[i].parentId
          });
          for (let x = 0; x < region[i].children.length; x++) {
            this.cityData.push({
              name: region[i].children[x].title,
              value: region[i].children[x].id,
              parent: region[i].children[x].parentId
            });
            for (let y = 0; y < region[i].children[x].children.length; y++) {
              this.cityData.push({
                name: region[i].children[x].children[y].title,
                value: region[i].children[x].children[y].id,
                parent: region[i].children[x].children[y].parentId
              });
            }
          }
        }
      }
    },
    getApproveInfo() {
      approveInfo()
        .then(res => {
          this.params.legalPerson = res.realName;
          this.params.legalPersonPhone = res.phone;
          this.params.legalPersonId = res.idCardNumber;
          this.params.legalPersonIdcardSurfaceUrl = res.idCardSurfaceUrl;
          this.params.legalPersonIdcardEmblemUrl = res.idCardEmblemUrl;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCompanyDetail() {
      getCompanyDetail({ companyId: this.companyId })
        .then(res => {
          if (res) {
            this.params = res;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    submit() {
      let that = this;
      this.$vux.loading.show();
      if (!this.params.companyName) {
        this.$showMessage("请输入公司名称");
      } else {
        companySubmit(this.params)
          .then(() => {
            this.$vux.loading.hide();
            if (that.$route.query.from == "cardList") {
              this.$router.push({ path: "/bankCard/bankCard?topIndex=1" });
            } else {
              this.$router.push({ path: "/profile" });
            }
          })
          .catch(err => {
            this.$vux.loading.hide();
            this.$showError(err);
          });
      }
    }
  }
};
</script>

<style>
input {
  border: none;
  background: #fff;
  width: 100%;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.getInfoButton {
  background: #fff;
  height: 40px;
  line-height: 40px;
  width: 160px;
  text-align: center;
  font-size: 12px;
  border: 1px solid #2b80fe;
  color: #2b80fe;
  border-radius: 40px;
  float: right;
}
.infoWrapper {
  margin-bottom: 20px;
  overflow: hidden;
}
.bg {
  background: #f3f3f3;
}
.infoLine {
  padding: 30px;
  background: #fff;
  border-bottom: 1px solid #f1f1f1;
}
.infoTitle {
  width: 140px;
  font-size: 14px;
  color: #474747;
  position: relative;
}
.infoText {
  text-align: right;
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}
.infoText input {
  font-size: 14px;
  line-height: 28px;
  width: 100%;
  text-align: right;
}
.uploadBox {
  position: relative;
  margin-top: 20px;
  overflow: hidden;
}
.uploadImgBox {
  position: relative;
  width: 150px;
  height: 150px;
}
.uploadImgBox img {
  width: 100%;
  height: 100%;
}
.tip {
  display: block;
  float: right;
  width: 28px;
  height: 28px;
  font-size: 12px;
  line-height: 28px;
  border-radius: 20px;
  border: 1px solid #2b80fe;
  color: #2b80fe;
  text-align: center;
  position: relative;
}
.tipText {
  position: absolute;
  font-size: 11px;
  height: 40px;
  line-height: 40px;
  padding: 0 30px;
  background: #f1f1f1;
  color: #2b80fe;
  top: -50px;
  right: 0;
  border-radius: 20px;
}
.saveButton {
  margin-top: 44px;
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: #fff;
  background: #2b80fe;
  text-align: center;
}
</style>
